import { Blackjack } from 'game-logic';
import { GameServices } from '../../services/game-services';
import { BehaviorSubject, Observable } from 'rxjs';
import { MiniChipViewModel } from '../chips/mini-chip-view-model';
import { BlackjackStylesType } from '../../model/blackjack-types';

export class PlayerMiniBetViewModel {
  public get betAmount$(): Observable<number> {
    return this.betAmount.asObservable();
  }
  public get betDoubled$(): Observable<boolean> {
    return this.betDoubled.asObservable();
  }
  public get defaultFontFamily() {
    return this.gameServices.gameThemeService.defaultFontFamily;
  }
  public get labelFill() {
    return this.gameServices.gameThemeService.getHexColor(BlackjackStylesType.LabelFill);
  }

  public readonly miniChipViewModel: MiniChipViewModel;

  private readonly betAmount: BehaviorSubject<number>;
  private readonly betDoubled: BehaviorSubject<boolean>;

  constructor(private gameServices: GameServices) {
    this.miniChipViewModel = new MiniChipViewModel(gameServices);
    this.betAmount = new BehaviorSubject<number>(0);
    this.betDoubled = new BehaviorSubject<boolean>(false);
  }

  public setBetAmount(betAmount: number): void {
    const highestChipDenom = highestDenomination(betAmount);
    this.miniChipViewModel.setChipValue(highestChipDenom);

    this.betAmount.next(betAmount);
  }

  public setBetDoubled(doubled: boolean): void {
    this.miniChipViewModel.showDoubleChips(doubled);
    this.betDoubled.next(doubled);
  }
}

function highestDenomination(amount: number): Blackjack.ChipDenomination {
  const denominations = Object.values(Blackjack.ChipDenomination).filter(
    (value) => typeof value === 'number',
  ) as number[];

  // Sort denominations in descending order
  denominations.sort((a, b) => b - a);

  for (const denom of denominations) {
    if (amount >= denom) {
      return denom;
    }
  }
  return Blackjack.ChipDenomination.Chip10;
}
